import { Placement } from '../../../../constants/recommendations';
import type { ListingsAPIRecommendationPlacement } from '../types';
import { UnreachableError } from '../types';

export const getTitle = (placement: ListingsAPIRecommendationPlacement): string | undefined => {
  switch (placement) {
    case Placement.SimilarProducts:
      return 'Similar products';
    case Placement.SameSeller2:
      return 'Partner best sellers';
    default:
      throw new UnreachableError(
        placement,
        `This placement type ("${placement}") does not have an associated title`,
      );
  }
};
